<div class="data-wrap" fxLayout="column">
    <div class="title">
        <mat-icon>update</mat-icon><span>{{ navData.data.title }}</span>
    </div>
    <div i18n class="desc">
        <span>Would you like to update the resource to the latest version?</span>
    </div>
    <ng-container *ngIf="resource$ | async as resource">
        <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap=".5em" class="dates">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span i18n>Current version:</span>
                <span>{{ navData.data.resourceItem.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span i18n>Original version:</span>
                <span>{{ resource.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }} </span>
            </div>
        </div>
        <div class="version-info">
            {{ compareVersion(navData.data.resourceItem.updated_at, resource.updated_at?.toISOString()) }}
        </div>
        <div fxFlex="1 0 100%" fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap=".5em" class="mt-1">
            <button class="cancelBtn" mat-raised-button (click)="onClose.emit()" i18n>Keep current</button>
            <button
                mat-raised-button
                color="primary"
                (click)="
                    onClose.emit({
                        action: SideNaveActionsTypes.POSITIVE,
                        data: { resource: resource, type: this.navData.data.type }
                    })
                "
                i18n
            >
                Update
            </button>
        </div>
    </ng-container>
</div>
